import Vue from 'vue';
import {
  Carousel, CarouselItem, Menu, Submenu, MenuItem, Input, Message,
} from 'element-ui';

Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Input);
Vue.prototype.$message = Message;
